import { SROnly } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

export const LoaderImage = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto;

  div {
    position: absolute;
    border: 2px solid;
    opacity: 1;
    border-radius: 50%;
    animation: loader-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    border-color: var(--colors-royalPurple);
  }

  &,
  div:nth-child(2) {
    animation-delay: -0.75s;
  }

  @keyframes loader-ripple {
    0% {
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      width: 100px;
      height: 100px;
      opacity: 0;
    }
  }
`;

const Loader = () => (
  <>
    <SROnly aria-live="assertive">Loading</SROnly>
    <LoaderImage>
      <div />
      <div />
    </LoaderImage>
  </>
);

export default Loader;
